import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-policy-linked-to-another-email-screens',
  templateUrl: './policy-linked-to-another-email-screens.component.html',
})
export class PolicyLinkedToAnotherEmailScreensComponent implements OnInit {
  user: any;
  isAcmic: boolean;

  constructor(private acmicService: AcmicService) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
  }
}
